export default __webpack_public_path__ + "static/media/a011-example13_tc.30cd5408.png";